module.exports = __webpack_public_path__ + "img/checkout-coat.9c05584f.svg";